<template>
    <div class="step">
        <div class="containerStepImg">
            <img :id="anim" class="imgStep" :src="getImgUrl(img)" :alt="alt">
        </div>
        <p class="stepTitle">{{ title }}</p>
        <p class="stepMsg">{{ msg }}</p>
    </div>
</template>
 

<script>
export default {
    name: 'step',
    props: {
        alt: String,
        img: String,
        title: String,
        msg: String,
        anim:String
    },
    methods: {
        getImgUrl: function(img) {
            return require('@/assets/imagesHome/'+img)
        }
    },
    mounted() {
        const step0 = this.$scrollmagic.scene({
          triggerElement: '#triggerStep0',
          duration: 100
        })
        .setTween( "#animStep0", 0.5, {width:'100px'})
        // .addIndicators({ name: 'Anim step0 (duration: 100)' })

        const step1 = this.$scrollmagic.scene({
          triggerElement: '#triggerStep1',
          duration: 100
        })
        .setTween( "#animStep1", 0.5, {width:'100px'})
        // .addIndicators({ name: 'Anim step1 (duration: 100)' })

        const step2 = this.$scrollmagic.scene({
          triggerElement: '#triggerStep2',
          duration: 100
        })
        .setTween( "#animStep2", 0.5, {width:'100px'})
        // .addIndicators({ name: 'Anim step2 (duration: 100)' })
      
        this.$scrollmagic.addScene([step0, step1, step2])
    } 

}
</script>


<style scoped lang="scss">
.step {
    /* max-width:300px; */
    margin-top:50px;
}

.stepTitle {
    font-size: 28px;
    line-height: 35px;
    height: 35px;
}

.stepMsg {
    text-align:center;
    font-weight: 300;
    margin-top:20px;
}

.containerStepImg {
    height: 90px;
    margin-bottom:50px;
}

.imgStep{
    width:1%;
}

@media (max-width:576px) {
  .step {
    width:100%;
    padding:0 15px;
  }
}
</style>